<template>
  <div class="page-continer personal-menus">
    <div class="left-menu">
      <img v-if="userInfo.avatar" class="avatar" :src="userInfo.avatar" />
      <img
        v-else
        class="avatar"
        src="//kandian-1254383113.file.myqcloud.com/cloud/pc/default-avatar.png"
      />
      <div v-if="userInfo.name" class="user-name">
        {{ userInfo.name }}，你好
      </div>
      <div v-else class="user-name">你好</div>
      <div class="phone-name">{{ userInfo.tel }}</div>
      <div class="menus">
        <div
          class="box"
          :class="{ active: pageName === 'baseInfo' }"
          @click="linkPage('/person/base')"
        >
          <div class="icon icon-1"></div>
          <div class="txt">基本信息</div>
        </div>
        <div
          class="box"
          :class="{ active: pageName === 'myCourse' }"
          @click="linkPage('/person/course')"
        >
          <div class="icon icon-2"></div>
          <div class="txt">我的课程</div>
        </div>
        <div
          v-if="
            (userInfo.userData && userInfo.userData.isShowApply === 1)
          "
          class="box"
          :class="{ active: pageName == 'adultExamApply' }"
          @click="linkPage('/person/adultExamApply')"
        >
          <div class="icon icon-3"></div>
          <div class="txt">经济师证书申请通道</div>
        </div>
        <!-- <div class="box" :class="{'active': (pageName ==='exam' || pageName ==='examTransferPage')}" @click="linkPage('/person/exam')">
          <div class="icon icon-3"></div>
          <div class="txt">我的考试</div>
        </div> -->
        <!-- <div class="box">
          <img class="icon" src="../../assets/images/icons/icon-menu-3.png"/>
          <div class="txt">我的订单</div>
        </div>-->
      </div>
    </div>
    <div class="right-main">
      <keep-alive include="exam">
        <router-view></router-view>
      </keep-alive>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getCookie, clearCookie } from '../../utils/utils'
export default {
  name: 'meLayout',
  computed: {
    ...mapGetters(['userId', 'userInfo']),
  },
  data() {
    return {
      pageName: this.$route.name,
    }
  },
  watch: {
    $route(newVal) {
      this.pageName = newVal.name
    },
  },
  mounted() {
    let userId = getCookie('uid')
    if (!userId) {
      this.$store.dispatch('user/openLogin', true)
    }
  },
  methods: {
    linkPage(params) {
      this.$router.push(params)
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../../assets/css/style.scss';
.personal-menus {
  margin: 23px auto 76px;
  @include flex();
}

.left-menu {
  width: 243px;
  padding-bottom: 60px;
  margin-right: 15px;
  background-color: #fff;

  .avatar {
    width: 88px;
    height: 88px !important;
    display: block;
    border-radius: 50%;
    margin: 40px auto 17px;
  }

  .user-name {
    margin-bottom: 8px;
    font-size: 18px;
    color: #333;
    text-align: center;
  }

  .phone-name {
    margin-bottom: 60px;
    font-size: 15px;
    color: #333;
    text-align: center;
  }

  .menus {
    .box {
      height: 80px;
      border-left: 5px solid #fff;
      cursor: pointer;
      @include flex-vertical-center();

      &:hover,
      &.active {
        border-left: 5px solid $color-primary;
        background-color: #f8f8f8;
        .txt {
          color: $color-primary;
        }

        .icon {
          &.icon-1 {
            background: url(../../assets/images/icons/icon-menu-active-1.png)
              no-repeat left top;
            background-size: cover;
          }
          &.icon-2 {
            background: url(../../assets/images/icons/icon-menu-active-2.png)
              no-repeat left top;
            background-size: cover;
          }
          &.icon-3 {
            background: url(../../assets/images/icons/icon-menu-active-3.png)
              no-repeat left top;
            background-size: cover;
          }
        }
      }

      .icon {
        width: 24px;
        height: 24px;
        margin: 0 5px 0 34px;
        &.icon-1 {
          background: url(../../assets/images/icons/icon-menu-1.png) no-repeat
            left top;
          background-size: cover;
        }
        &.icon-2 {
          background: url(../../assets/images/icons/icon-menu-2.png) no-repeat
            left top;
          background-size: cover;
        }
        &.icon-3 {
          background: url(../../assets/images/icons/icon-menu-3.png) no-repeat
            left top;
          background-size: cover;
        }
      }

      .txt {
        font-size: 16px;
        color: #999999;
      }
    }
  }
}

.right-main {
  flex: 1;
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/personal/layout.vue